import {GenericLoader} from "@twigsby/frontend-framework";
import React, {useEffect} from "react";
import {useUKPBAuth} from "../../Providers/AuthProvider";

const OAuthRedirect = () => {
    const { token, loginInProgress, loggingOut, RedirectError, LogInSuccess } = useUKPBAuth();

    useEffect(() => {
        if(!loggingOut.current && !loginInProgress && token === '') {
            RedirectError(true);
        } else if(token && !loginInProgress) {
            LogInSuccess();
        }
    }, [token, loginInProgress ]);

    return (
        <div className={'fill-container'}>
            <GenericLoader size={"4x"} />
        </div>
    )
}

export default OAuthRedirect
